export default __webpack_public_path__ + "static/media/leagues-img.08446274.jpg";